import React from 'react'
import './Spinner.css'

const SpinnerUI = ({className, show, reserveSpace, dimension}) =>
  <div className={`w_spinner ${dimension || 'w20'} ${show ? 'show' : 'hide'} ${reserveSpace ? 'space' : 'no-space'} ${className}`}>
  </div>

export default SpinnerUI
